<div *ngIf="title" class="section-title bold" [ngClass]="{ 'section-title--isDetail': isDetail }">
  <span class="title-wrapper"> {{ title }} <ng-content select="[additionalTitleContent]"> </ng-content> </span>
</div>
<ng-content></ng-content>
